module.exports = __webpack_public_path__ + "img/bg.14980a8e.png";